import axios from './axios';
import SETTINGS from '../settings'
export default {
    getContentSection(id, query, cb) {
        axios.get(`${SETTINGS.API_BASE_PATH}/customcontenttabs/${id}`, {params: query}).then(response => {
            cb(response.data)
        }).catch(e => {
            console.log(e)
        })
    },
}